function Nuggets() {
  return (
    <>
      <section class="l-contain l-section l-section--separated" id="nuggets">
        <h2 class="u-small-title">FUN PRODUCT NUGGETS</h2>
        <p className="c-meta boss_baby boss_baby1">
          Courtesy of Theodore Templeton (The Boss Baby)
        </p>
        <p className="c-meta boss_baby">
          My favourite Product show of all time is{" "}
          <span className="boss-baby-highlights">
            Boss Baby: Back in Business
          </span>
          . Yes, the famous animated series is based on Product and Business
          Management. Here are
          <span className="boss-baby-highlights"> Seven (7)</span> valuable
          Product lessons to be learnt from the first few episodes of Boss Baby.
        </p>
        <ul class="u-simple-list | home-product-list split-list">
          <li class="c-limit-width | product-role__list-item about-li">
            Project Yellow 100 was just another way of depicting market share,
            and Baby Corp wanted to achieve 100% market share with their
            product, babies. A product must always pronounce its unique value
            proposition, above that of the competitors, so as to achieve a
            greater market share.
          </li>
          <li class="c-limit-width | product-role__list-item about-li">
            Not all malfunctioning products can be called back from the market,
            for example, it would be practically impossible to call back an
            ever-crying baby, as this would distabilise and cause hardship to
            its parents/customer. Thus, maintenance after deployment is vital.
            This would help to understand how to better improve on the product.
          </li>
          <li class="c-limit-width | product-role__list-item about-li">
            During maintenance or fixing of a malfunctioning product, a customer
            can be incentivized with other products that will help or distract
            them from the inconvenience, just like Scooter Buskie’s parents were
            given a baby's toy to assemble while their baby was getting fixed.
          </li>
          <li class="c-limit-width | product-role__list-item about-li">
            Not all supplementary products are parallel products, some can be
            your direct competitors, just like Bubbeezee!
          </li>
          <li class="c-limit-width | product-role__list-item about-li">
            Be sure to brainstorm ideas with every member of your team while
            trying to solve a problem, even Jimbo’s null ideas and Staci’s
            extreme ideas were always heard. You cannot be too sure of where the
            best idea could come from!
          </li>
          <li class="c-limit-width | product-role__list-item about-li">
            Sometimes, it helps to approach the business from the personal and
            ordinary point of view of the customer, rather than from a business
            point of view. Empathy plays a big role in business!!! However, in
            as much as empathy is used, the Product Manager should always
            consider how the needs of the customer will ultimately suit the
            business needs.
          </li>
          <li class="c-limit-width | product-role__list-item about-li">
            A Product Manager must know how to leverage on the demand of a
            product to communicate usability.
          </li>
        </ul>
        <p className="boss-baby-footer">
          All of these from an animation? Watch Boss Baby to find out.
        </p>
      </section>
    </>
  );
}
export default Nuggets;
